<div class="qui-form-layout__col-center flex w-full flex-col gap-400">
  @if (allFieldsLocked()) {
    <app-locked-quote-alert></app-locked-quote-alert>
  }
  @if (isAutoAdvanceEnabled()) {
    <p class="sr-only">Selecting an option will immediately submit the form and take you to the next page. You cannot navigate backwards and change your selection.</p>
  }
  <form [formGroup]="exteriorWallForm" (ngSubmit)="handleSubmit($event)" id="quote-form">
    <app-form-card [title]="'What is the exterior wall finish of your home?'" icon="lucideHouse" formDisplayAddress="{{ formDisplayAddress }}">
      <div class="mt-600 grid grid-cols-1 gap-x-6 gap-y-6 md:gap-y-10">
        <fieldset class="form-group__fieldset" [appReadonlyRadioGroup]="isFieldLocked('exteriorWall')" [appFocusOnlyRadioGroup]="isAutoAdvanceEnabled()">
          <legend class="sr-only">Select the exterior wall type</legend>
          <div class="grid gap-200 md:grid-cols-2">
            @for (exteriorWallOption of exteriorWallOptions; track exteriorWallOption) {
              <label
                class="radio-card radio-card--block group focus-within:ring-primary focus-within:ring-2"
                [class.radio-card--invalid]="showError"
                [for]="exteriorWallOption.id"
                [attr.data-testid]="'exterior-wall-' + exteriorWallOption.id"
              >
                <div class="radio-card__header flex flex-col gap-100">
                  <div class="flex w-full items-start justify-start">
                    <img src="assets/images/{{ exteriorWallOption.image }}" alt="exterior wall image" class="rounded-200 border-1 !border-neutral-800" />
                    <div>
                      <p class="radio-card__title m-l-200 font-medium group-has-[:checked]:font-bold">{{ exteriorWallOption.label }}</p>
                      <p class="m-t-100 m-l-200">{{ exteriorWallOption.description }}</p>
                    </div>
                  </div>
                </div>
                <input class="radio-card__control peer outline-none" type="radio" [id]="exteriorWallOption.id" [value]="exteriorWallOption.id" formControlName="exteriorWall" />
              </label>
            }
          </div>
        </fieldset>
        @if (showError) {
          <div class="fs-body-md fw-medium error-message text-warning flex items-center gap-100" role="alert" data-testid="form-error-message" aria-live="polite" aria-atomic="true">
            <ng-icon name="lucideCircleAlert" size="16" class="!overflow-visible" aria-hidden="true"></ng-icon>
            Please make a selection
          </div>
        }
      </div>
    </app-form-card>
  </form>
  <div class="rounded-200 bg-primary-300 px-500 py-300" data-testid="help-text">
    <div class="flex items-start gap-300">
      <ng-icon name="lucideCircleHelp" size="24" class="[&>svg]:fill-primary !overflow-visible" aria-hidden="true"></ng-icon>
      <div class="flex flex-col gap-300">
        <div>
          <p><strong>Not sure how to answer?</strong></p>
          <p class="hidden md:block">If you'd like a little extra help, our licensed agents are here for you.</p>
          <p class="md:hidden">One of our licensed agents will be happy to help.</p>
        </div>
        <div class="hidden md:block">
          <p class="font-bold">{{ salesPhoneNumber | phone }}</p>
          <p>{{ salesPhoneHoursFormatted }}</p>
        </div>
      </div>
    </div>

    <button (click)="contactDialogService.open()" data-testid="help-text-href" class="button button--sm button--secondary mt-300 w-full items-center justify-center gap-100 text-center md:hidden">
      <ng-icon name="lucidePhone" size="16" class="!overflow-visible" aria-hidden="true"></ng-icon>
      Talk to an agent
    </button>
  </div>
</div>
